export const ADD_ORGANIZATION = 'add_organization';
export const ADD_ORGANIZATION_SUCCESS = 'add_organization_success';
export const ADD_ORGANIZATION_FAILURE = 'add_organization_failure';

export const UPDATE_ORGANIZATION = "update_organization";
export const UPDATE_ORGANIZATION_SUCCESS = "update_organization_success";
export const UPDATE_ORGANIZATION_FAILURE = "update_organization_failure";

export const DELETE_ORGANIZATION = "delete_organization";
export const DELETE_ORGANIZATION_SUCCESS = "delete_organization_success";
export const DELETE_ORGANIZATION_FAILURE = "delete_organization_failure";

export const GET_ORGANIZATIONS = "get_organizations";
export const GET_ORGANIZATIONS_SUCCESS = "get_organizations_success";
export const GET_ORGANIZATIONS_FAILURE = "get_organizations_failure";

export const GET_PRE_ON_BOARDED_ORGANIZATIONS = "get_pre_on_boarded_organizations";
export const GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS = "get_pre_on_boarded_organizations_success";
export const GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE = "get_pre_on_boarded_organizations_failure";

export const RESEND_ORG_ON_BOARD_ACTIVATION_LINK = "resend_org_on_board_activation_link";
export const RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS = "resend_org_on_board_activation_link_success";
export const RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE = "resend_org_on_board_activation_link_failure";

export const REGISTER_TRIAL_ACCOUNT_USER = "register_trial_account_user";
export const REGISTER_TRIAL_ACCOUNT_USER_SUCCESS =
  "register_trial_account_user_success";
export const REGISTER_TRIAL_ACCOUNT_USER_FAILURE =
  "register_trial_account_user_failure";

export const CLEAR_ALL_MESSAGES = "clear_all_messages";
export const CLEAR_ALL_MESSAGES_SUCCESS = "clear_all_messages_success";

export const CLEAR_SUCCESS_MESSAGES = "clear_success_messages";
export const CLEAR_SUCCESS_MESSAGES_SUCCESS = "clear_success_messages_success";

export const CLEAR_FAILURE_MESSAGES = "clear_failure_messages";
export const CLEAR_FAILURE_MESSAGES_SUCCESS = "clear_failure_messages_success";
